/*
 * Entrada de los bloques de contenido al hacer scroll.
 *
 * Vive aparte del runtime de la pagina de producto para poder usarse en toda
 * la tienda sin arrastrar la logica de lazyload, videos y carruseles, que solo
 * hace falta en las secciones heredadas de GemPages.
 *
 * Reconoce dos marcados:
 *   - Horizon nativo (home, paginas, coleccion)
 *   - las secciones dl-section-* de la pagina de producto
 *
 * Regla de oro: quien esconde es este script, no el CSS. Si falla o el
 * navegador no soporta IntersectionObserver, no se anima nada y todo queda
 * visible. Nunca al reves.
 */
(function () {
  'use strict';

  var SELECTORES = [
    '.custom-section-content > div > div', // Horizon
    'gp-row > div',                        // secciones heredadas
    'gp-row > gp-row',
  ].join(', ');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function iniciar() {
    if (reduce || !('IntersectionObserver' in window)) return;

    var candidatos = Array.prototype.filter.call(document.querySelectorAll(SELECTORES), function (el) {
      if (el.dataset.dlRevelar) return false;
      var r = el.getBoundingClientRect();
      if (r.height < 40 || r.width < 40) return false;
      if (el.closest('gp-animation')) return false;
      // Dentro de un carrusel la animacion pelea con el scroll-snap.
      if (el.closest('gp-carousel-v3, gp-carousel-v2, .gem-slider-wrapper')) return false;
      // El encabezado y cualquier cosa pegada no deben moverse.
      if (el.closest('header, .header, .cart-drawer')) return false;
      var pos = getComputedStyle(el).position;
      return pos !== 'fixed' && pos !== 'sticky';
    });

    // De cada rama se anima el bloque mas interno: animar el contenedor hace
    // aparecer la seccion entera de golpe en vez de sus piezas escalonadas.
    var finales = candidatos.filter(function (el) {
      return !candidatos.some(function (otro) {
        return otro !== el && el.contains(otro);
      });
    });

    var io = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          mostrar(e.target);
        });
      },
      { rootMargin: '0px 0px -60px 0px' }
    );

    finales.forEach(function (el) {
      el.dataset.dlRevelar = 'pendiente';
      el.style.opacity = '0';
      el.style.transform = 'translate3d(0, 18px, 0)';
      el.style.willChange = 'opacity, transform';
      io.observe(el);
    });

    function mostrar(el, alInstante) {
      if (el.dataset.dlRevelar === 'listo') return;
      var hermano = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      var retardo = Math.min(hermano, 4) * 0.07;
      // El rescate debe mostrar de golpe. Si aqui se pusiera la transicion,
      // el contenido volveria a depender de que el navegador la ejecute, que
      // es justo de lo que el rescate protege.
      el.style.transition = alInstante
        ? 'none'
        : 'opacity .55s cubic-bezier(.22,.61,.36,1) ' + retardo + 's, ' +
          'transform .55s cubic-bezier(.22,.61,.36,1) ' + retardo + 's';
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.dataset.dlRevelar = 'listo';
      setTimeout(function () {
        el.style.willChange = '';
      }, 900 + retardo * 1000);
    }

    // Red de seguridad: pase lo que pase con el observador, a los 4 segundos
    // todo esta visible.
    setTimeout(function () {
      finales.forEach(function (el) {
        if (el.dataset.dlRevelar !== 'listo') mostrar(el, true);
      });
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // El editor de temas reinyecta secciones sin recargar.
  document.addEventListener('shopify:section:load', iniciar);
})();
